import {
    ZingPlayFrames,
    isZingPlayFrameVersion,
} from '../../ReusableComponents/ByteTransfer/zingPlayFrame'

// Turning is MOVE_DIR left/right. Slide has its own DO_ACTION frames (SLIDELEFT/SLIDERIGHT), so it is not aliased.
const SPEECH_FRAME_ALIAS = {
    TURNLEFT: 'MOVELEFT',
    TURNRIGHT: 'MOVERIGHT',
}

const getZingSpeechBytes = (
    command,
    connectedDevice,
    deviceVersion,
    legacyCodes
) => {
    if (isZingPlayFrameVersion(connectedDevice, deviceVersion)) {
        const frame = ZingPlayFrames[SPEECH_FRAME_ALIAS[command] ?? command]
        if (frame) return frame
    }
    return legacyCodes?.[command]
}

export { getZingSpeechBytes }
